import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Theme,
  Box,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AppTableHeaderCell from "../../common/pages/AppTableHeaderCell";
import { StyledTableRow } from "../../../../styles/Shipmentstyles";
import AppTableRowCell from "../../common/pages/AppTableRowCell";
import CustomTypography from "../../common/form/CustomTypography";
import pencil_uderline from "../../../../assets/pencil_uderline.png";
import open_box from "../../../../assets/Boxopen.svg";
import { Dayjs } from "dayjs";
import "dayjs/locale/en-gb";
import { PackagingSwagpack } from "../../../../models/ProjectManagement/ProjectPackagingSwagpacks";
import { observer } from "mobx-react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { formatDate } from "../../common/functions/formatDate";
interface PackagingOpsTableProps {
  maxHeight?: number;
  minHeight?: number;
  handleNavigateById?: (id: number) => void;
  handlePencilClick?: (
    productId: number,
    taskName: string,
    currentDate: Dayjs | null,
  ) => void;
  handleDeletePack: (swagpack_id: number, inventory_id: number) => void;
  handleAddClick?: (swagpack: PackagingSwagpack) => void;
  swagpacks: PackagingSwagpack[];
  isLoading: boolean;
  archived?: number;
  handleImageUpload?: (pack: PackagingSwagpack) => void;
  hasCreateSwagpackPermission?: boolean;
}

const PackagingOpsTable: React.FC<PackagingOpsTableProps> = ({
  handlePencilClick,
  handleDeletePack,
  handleAddClick,
  swagpacks,
  maxHeight,
  minHeight = window.innerHeight - 420,
  archived,
  handleImageUpload,
  hasCreateSwagpackPermission = false,
}) => {
  const theme = useTheme<Theme>();
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  return (
    <TableContainer sx={{ maxHeight: maxHeight, minHeight: minHeight }}>
      <Table stickyHeader>
        {" "}
        <TableHead>
          <TableRow>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              sx={{ paddingLeft: 2, width: "300px" }}
              txtAlign="left"
            >
              NAME
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              TYPE
            </AppTableHeaderCell>

            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              QTY FROM ORDER
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              INITIAL QTY
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              AVL QTY
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              CREATED BY
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              CREATED DATE
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              LAST MODIFIED BY
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="left"
            >
              MODIFIED DATE
            </AppTableHeaderCell>
            <AppTableHeaderCell
              minWidth="0.75rem"
              fontSize="0.75rem"
              fontColor={theme?.palette?.customColors?.blackBodyBackgorund}
              txtAlign="center"
              sx={{
                position: "sticky",
                right: 0,
                backgroundColor: theme?.palette?.customColors?.white,
              }}
            >
              ACTION
            </AppTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {swagpacks?.map((item) => (
            <StyledTableRow key={item?.swagpack_id}>
              <AppTableRowCell
                fontSize="1rem"
                textAlign="left"
                sx={{ display: "flex", alignItems: "center", width: "300px" }}
              >
                <Box
                  sx={{
                    position: "relative",
                    background: "rgba(242, 242, 242, 1)",
                    padding: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: 2,
                    minHeight: "55px",
                    maxHeight: "55px",
                    borderRadius: "4px",
                  }}
                  onMouseEnter={() => setHoverIndex(item?.swagpack_id)}
                  onMouseLeave={() => setHoverIndex(null)}
                >
                  <img
                    style={{
                      maxHeight: "38px",
                      minHeight: "38px",
                      maxWidth: "38px",
                      minWidth: "38px",
                    }}
                    src={item?.pack_image_url || open_box}
                    alt={item?.swagpack_name}
                  />
                  {hoverIndex === item?.swagpack_id && (
                    <Box
                      className="delete-icon-2"
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#00000020",
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                        alignItems: "center",
                        opacity: 1,
                        transition: "opacity 0.3s ease-in-out",
                        zIndex: 1000,
                      }}
                    >
                      <VisibilityOutlinedIcon
                        sx={{
                          color: "#fff",
                          cursor: "pointer",
                          backgroundColor: "#00000090",
                          borderRadius: "50%",
                          padding: "4px",
                          height: 20,
                          width: 20,
                        }}
                        onClick={() => handleImageUpload!(item)}
                      />
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1.781rem",
                    paddingLeft: "10px",
                  }}
                >
                  <Box
                    sx={{
                      whiteSpace: "pre-line",
                      textAlign: "left",
                      cursor: "pointer",
                    }}
                    onClick={() => {}}
                  >
                    <CustomTypography
                      variant="body2"
                      color={theme?.palette?.customColors?.blackBodyBackgorund}
                    >
                      {item?.swagpack_name}
                    </CustomTypography>
                    <CustomTypography
                      variant="body3"
                      color={theme?.palette?.customColors?.greyTextColor}
                      style={{ paddingTop: 5 }}
                    >
                      ID: #{item?.swagpack_id}
                    </CustomTypography>
                  </Box>
                </Box>
              </AppTableRowCell>
              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                <span
                  style={{
                    borderRadius: "17px",
                    padding: "2px 12px",
                    display: "inline-flex",
                    justifyContent: "center",
                    backgroundColor:
                      item?.products?.length > 1
                        ? theme?.palette?.customColors?.greenLight
                        : theme?.palette?.lavenderBlue?.light,
                    color:
                      item?.products?.length > 1
                        ? theme?.palette?.customColors?.blackBorder
                        : theme?.palette?.blue?.main,
                  }}
                >
                  {item?.products
                    ? item.products.length > 1
                      ? "Swagpack (" + item.products.length + ")"
                      : "Bulk"
                    : "-"}
                </span>
              </AppTableRowCell>
              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {item?.quantity_this_order || "-"}
              </AppTableRowCell>
              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {item?.quantity}
              </AppTableRowCell>
              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {item?.quantity - item?.used_quantity}
              </AppTableRowCell>

              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {item.created_by_name || "-"}
              </AppTableRowCell>

              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {formatDate(item?.created_date)}
              </AppTableRowCell>

              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {item?.last_modified_by_name || "-"}
              </AppTableRowCell>

              <AppTableRowCell sx={{ fontSize: "0.8rem" }}>
                {formatDate(item?.modified_date)}
              </AppTableRowCell>

              <AppTableRowCell
                sx={{
                  position: "sticky",
                  right: 0,
                  backgroundColor: theme?.palette?.customColors?.white,
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "16px",
                  }}
                >
                  {hasCreateSwagpackPermission && (
                    <IconButton
                      size="small"
                      onClick={() => handleAddClick?.(item)}
                      sx={{ padding: 0 }}
                      disabled={archived === 1}
                    >
                      <img
                        src={pencil_uderline}
                        alt="edit-icon"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </IconButton>
                  )}
                  <IconButton
                    size="small"
                    onClick={() =>
                      handlePencilClick?.(item?.swagpack_id, "TaskName", null)
                    }
                    sx={{ padding: 0 }}
                    disabled={archived === 1}
                  >
                    <RemoveRedEyeOutlinedIcon />
                  </IconButton>

                  <IconButton
                    onClick={() =>
                      handleDeletePack(item?.inventory_id, item?.swagpack_id)
                    }
                    disabled={
                      archived === 1 ||
                      Number(item.quantity - item.used_quantity) === 0
                    }
                    sx={{
                      padding: 0,
                      opacity:
                        archived === 1 ||
                        Number(item.quantity - item.used_quantity) === 0
                          ? 0.4
                          : 1,
                      cursor:
                        archived === 1 ||
                        Number(item.quantity - item.used_quantity) === 0
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <DeleteIcon
                      sx={{
                        color: theme?.palette?.customColors?.pinkDark,
                        width: 22,
                        height: 22,
                      }}
                    />
                  </IconButton>
                </Box>
              </AppTableRowCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>

      {swagpacks?.length === 0 && (
        <Box
          sx={{
            display: "flex",
            minHeight: "100px",
            paddingTop: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomTypography
            color={theme?.palette?.customColors?.greyTextColor}
            variant="heading8"
          >
            NO PACK OR BULK ITEM FOUND!
          </CustomTypography>
        </Box>
      )}
    </TableContainer>
  );
};

export default observer(PackagingOpsTable);
